const or = (...predicates) => {
  return traffic => {
    return predicates.some(predicate => {
      return predicate(traffic)
    })
  }
}

export default or



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/organizedByType/vms/ads/trafficAnalyzer/predicates/or.js